import React from "react";
import { HStack, Icon, Menu, MenuButton, MenuItem, MenuList, Spinner, Text } from "@chakra-ui/react";
import { FaFileExport } from "react-icons/fa";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";

export const BalanceSheetActions = ({ isExporting, onExport }) => (
  <Menu>
    <ReportMenuButton disabled={isExporting}>
      <HStack spacing={2}>
        {isExporting ? <Spinner size="xs" /> : <Icon as={FaFileExport} />}
        <Text>{isExporting ? "Exporting..." : "Export"}</Text>
      </HStack>
    </ReportMenuButton>
    <MenuList {...reportToolbarStyles.menuList}>
      <MenuItem onClick={() => onExport("PDF")}>To PDF</MenuItem>
      <MenuItem onClick={() => onExport("Excel")}>To Excel</MenuItem>
    </MenuList>
  </Menu>
);
